var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 108.46 93.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f7f7f7;}.cls-2{fill:#606161;}.cls-3{fill:#fff;}.cls-4{fill:#707071;}.cls-5{fill:#d8d8d8;opacity:0.7;}.cls-6{fill:#c3c4c4;}.cls-7{fill:#999;}.cls-8{fill:#636666;}.cls-9{fill:#e6e9e9;}.cls-10{fill:#919190;}.cls-11{fill:#676868;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\uC790\uC0B0 5@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uB808\\uC774\\uC5B4_2",
    "data-name": "\\uB808\\uC774\\uC5B4 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uB808\\uC774\\uC5B4_1-2",
    "data-name": "\\uB808\\uC774\\uC5B4 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M107.6,93.55C104.13,65,95,45.16,95,45.16l.53-.27a5.11,5.11,0,0,0,3.21-3.29,7.32,7.32,0,0,0,.3-2.05,5.09,5.09,0,0,0,5.37-7.37c3-.72,4.44-4.53,3-7.2a6,6,0,0,0-1.34-1.61c3.22-1.55,2.91-6.66.61-8.8a5.42,5.42,0,0,0-2.24-1.26c2.45-3.68-.73-9.55-5.13-9.28-3.28.2-4.12,3-5,5.69C88.37,27.56,68.08,20.09,68.08,20.09c-8.52-3-19.24-3.23-27.7,0l-.64.21S20.09,27.56,14.14,9.72c-.88-2.65-1.72-5.49-5-5.69C4.74,3.76,1.56,9.63,4,13.31a5.57,5.57,0,0,0-2.25,1.26c-2.3,2.14-2.6,7.25.62,8.8A6,6,0,0,0,1,25c-1.4,2.67,0,6.48,3,7.2a5.29,5.29,0,0,0,.51,5.49,5.3,5.3,0,0,0,4.86,1.88,7.32,7.32,0,0,0,.3,2.05A5.11,5.11,0,0,0,13,44.89l.53.27S4.33,65,.86,93.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M54.23,57.16a4.49,4.49,0,1,0-4.49-4.49A4.5,4.5,0,0,0,54.23,57.16Zm0-6.36a1.87,1.87,0,1,1-1.87,1.87A1.87,1.87,0,0,1,54.23,50.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M52.92,60.13a1.31,1.31,0,0,1,2.62,0v4.35A17.66,17.66,0,0,1,65,67.93a1.16,1.16,0,0,1,.2,1.71,1.36,1.36,0,0,1-1.84.19,14.56,14.56,0,0,0-8.21-2.92,16.9,16.9,0,0,0-4.49.36,15,15,0,0,0-4,1.58,16.8,16.8,0,0,0-1.5,1,1.35,1.35,0,0,1-1.83-.19,1.16,1.16,0,0,1,.2-1.71,17.66,17.66,0,0,1,9.43-3.45v-.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M12.68,45.27A5.06,5.06,0,0,0,16.81,45a6.24,6.24,0,0,0,4.91,2.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M21.26,47.66a6.68,6.68,0,0,1-4.56-2,5.59,5.59,0,0,1-4.21.11.5.5,0,1,1,.39-.92,4.64,4.64,0,0,0,3.68-.24.5.5,0,0,1,.63.11,5.74,5.74,0,0,0,4.49,2,.5.5,0,0,1,.09,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M95.9,45.27A5.06,5.06,0,0,1,91.77,45a6.24,6.24,0,0,1-4.91,2.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M87.32,47.66l-.51,0a.51.51,0,0,1-.45-.55.52.52,0,0,1,.54-.45,5.76,5.76,0,0,0,4.49-2,.5.5,0,0,1,.63-.11,4.58,4.58,0,0,0,3.68.24.5.5,0,0,1,.4.92,5.57,5.57,0,0,1-4.22-.11A6.68,6.68,0,0,1,87.32,47.66Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 28.42,
    cy: 57.56,
    rx: 6.26,
    ry: 3.75
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 80.04,
    cy: 57.56,
    rx: 6.26,
    ry: 3.75
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M40.29,19.44s-.83-.08-.83,1.5v3.72s.64,3.1,13.88,3.1c0,0,12.06.69,13.88-3.1V20.23s.07-1.1-.79-1.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M55.57,28.06c-1.25,0-2.12,0-2.24,0h0c-13.27,0-14.07-3.17-14.1-3.3V20.94a2,2,0,0,1,.48-1.51.89.89,0,0,1,.62-.24l-.05.5,0-.25,0,.25a.39.39,0,0,0-.25.12,1.51,1.51,0,0,0-.31,1.13v3.72h0s1,2.85,13.63,2.85c.13,0,11.82.63,13.63-2.91V20.23a1.17,1.17,0,0,0-.2-.72.44.44,0,0,0-.34-.13v-.5a1,1,0,0,1,.71.29,1.59,1.59,0,0,1,.33,1.07l0,4.53C66.06,27.67,59.2,28.06,55.57,28.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M65.75,15.9c.81,0,.75,1,.75,1v4.2c-13.16,5.55-26.32,0-26.32,0V17.62c0-1.5.78-1.42.78-1.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M53.87,23.84a39.27,39.27,0,0,1-13.78-2.47l-.16-.06V17.62a1.94,1.94,0,0,1,.46-1.45A.81.81,0,0,1,41,16l-.05.5a.3.3,0,0,0-.22.1,1.47,1.47,0,0,0-.29,1.07V21c1.5.59,13.72,5,25.82,0v-4a1.08,1.08,0,0,0-.19-.67.39.39,0,0,0-.31-.12v-.5a.92.92,0,0,1,.68.28,1.52,1.52,0,0,1,.32,1v4.35l-.16.06A32.6,32.6,0,0,1,53.87,23.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M40.54,15.77a5.27,5.27,0,0,0-2.3,1.16s11.81,2.81,15.1,4.39c0,0,13.55-4.52,15.28-4.39a3.63,3.63,0,0,0-2.12-1.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M53.32,21.58l-.09,0C50,20,38.3,17.2,38.18,17.18l-.45-.11.34-.32a5.52,5.52,0,0,1,2.42-1.23l.1.49a5.44,5.44,0,0,0-1.8.8c2.27.55,11.53,2.83,14.57,4.24,1.2-.4,11.69-3.88,14.68-4.32A3.42,3.42,0,0,0,66.46,16l.08-.49a3.91,3.91,0,0,1,2.27,1.25l.37.46-.58-.05h-.08c-1.63,0-11.41,3.14-15.1,4.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M40.54,13.84v1.87s10.06,3.89,26,0V12.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M52.75,17.68a37.48,37.48,0,0,1-12.3-1.74l-.16-.06v-2h.5v1.69c1.35.47,11,3.47,25.46,0V12.08h.5v3.83l-.19,0A57.73,57.73,0,0,1,52.75,17.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M65.64,9.18c4.84.12,3.94,2.87,3.94,2.87-.41,1.81-2.52,1.46-2.52,1.46-1.78-1.08-4.35-.35-4.35-.35-1.42.32-2.37,1.89-3.75,2.33a1.19,1.19,0,0,1-.42.06c-1.77,0-3.47-1.24-5.28-.92s-3.27,1.55-5,1c-1.5-.46-2.85-1.9-4.43-1.9h-.24c-1.51.09-3.15.57-4.63-.28l0,0s-2.09-1.26-1.46-2.94c0,0,.67-1.64,3.34-1.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M65.64,9.43c1.4.08,4.14.46,3.72,2.48s-2.29,1.15-3.5.88a6.67,6.67,0,0,0-3.17.11c-2.24.66-2.76,2.68-5.59,2.16-1.7-.31-2.87-1-4.63-.49s-3,1.23-4.8.54c-.88-.34-1.61-1-2.49-1.31-2-.77-4.14.41-6.14-.57-.73-.35-.88-.9-1.1-1.66-.53-1.82.82-2.2,2.74-1.91.31.05.45-.43.13-.48-3.12-.47-5.43,2.35-2.14,4.41a4.72,4.72,0,0,0,2.54.6c.86,0,1.72-.26,2.57-.21,1.5.1,2.39,1.08,3.67,1.61a4.32,4.32,0,0,0,3,.21c.73-.17,1.4-.56,2.13-.75,1.65-.42,2.83.13,4.37.49,2.9.68,3.49-1.56,6.15-2.22,1.55-.39,2.66.35,4.11.46a2.66,2.66,0,0,0,2-.6A2.3,2.3,0,0,0,69.82,11c-.5-1.73-2.69-1.94-4.18-2-.32,0-.32.48,0,.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M67.31,10.21S67,.25,54.5.25h-2c-12.5,0-12.8,10-12.8,10S50.92,14.91,67.31,10.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M52.93,12.53a37.89,37.89,0,0,1-13.29-2.09l-.16-.06V10.2C39.49,10.1,40,0,52.54,0h2c12.59,0,13,10.1,13.06,10.2v.2l-.18,0A52.48,52.48,0,0,1,52.93,12.53ZM40,10c1.44.55,12.11,4.21,27.05,0C66.93,8.62,65.79.5,54.5.5h-2C41.33.5,40.12,8.74,40,10Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 53.44,
    cy: 2.02,
    rx: 0.35,
    ry: 0.26
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 51.57,
    cy: 3.66,
    rx: 0.35,
    ry: 0.26
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 55.11,
    cy: 3.66,
    rx: 0.35,
    ry: 0.26
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 57.03,
    cy: 2.41,
    rx: 0.35,
    ry: 0.26
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 49.79,
    cy: 2.41,
    rx: 0.35,
    ry: 0.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M42.37,46.25h-.51a1,1,0,0,1-1-1,1,1,0,0,1,1-1c4,.13,4.8-1.61,4.8-1.63a1,1,0,0,1,1.88.68C48.57,43.41,47.49,46.25,42.37,46.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66.09,46.25c-5.12,0-6.2-2.84-6.24-3a1,1,0,0,1,1.87-.7c.05.11.86,1.78,4.81,1.65a1,1,0,0,1,1,1,1,1,0,0,1-1,1Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSad);
export default __webpack_public_path__ + "static/media/Sad.5dc2c6bfd8757ee4e2b5d883172150dc.svg";
export { ForwardRef as ReactComponent };